import React from "react";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import Badge from "../../../components/Common/Badge";
import { FaPlus } from "react-icons/fa6";
import { FaSync } from "react-icons/fa";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import { AppContext } from "../../../contexts/AppContext";
import { handleChangeTableCheckbox } from "../../../helpers/handleFormChanges";
import CommonsHelper from "../../../helpers/CommonsHelper";
import { formataData } from "../../../helpers/mesesHelper";
import Format from "../../../helpers/Format";
import PropTypes from "prop-types";
import useTipos from "../../../hooks/common/useTipos";

function GerenciadorDataTable({
  linhas,
  togUploadModal,
  togVisualizarModal,
  checkboxesHook,
  togEnviarEmailModal,
  downloadNotaFiscal,
  deleteNotaFiscal,
  inativarNotaFiscal,
  cancelarNotaFiscal,
  solicitarCancelamento,
  togDownloadMassaModal,
  atualizarNota,
  togVisualizarJson,
  cancelarPrefeitura,
  togEmailMassaModal,
  sincronizarNotas,
  downloadDocumento,
}) {
  const { checkboxesMarcados, setCheckboxesMarcados } = checkboxesHook;
  const { session, baseUrl } = React.useContext(AppContext);
  const isMobile = CommonsHelper.isMobile();
  const tiposNotaFiscal = useTipos("tipos_nota_fiscal");

  const colunas = React.useMemo(
    () => [
      {
        Header: "",
        accessor: "id",
        disableSortBy: true,
        Cell: ({ row }) => (
          <input
            className="form-check-input"
            type="checkbox"
            name="nfs"
            value={row.original.uid}
            checked={checkboxesMarcados.includes(String(row.original.uid))}
            onChange={(e) => {
              handleChangeTableCheckbox(
                e,
                checkboxesMarcados,
                setCheckboxesMarcados
              );
            }}
          />
        ),
      },
      {
        Header: "Tipo",
        accessor: (row) => {
          return row.tipo_nota
            ? (tiposNotaFiscal &&
                tiposNotaFiscal.find(
                  (tipoNota) =>
                    parseInt(tipoNota.chave) === parseInt(row.tipo_nota)
                )?.valor) ||
                "-"
            : "-";
        },
      },
      {
        Header: "Tomador",
        accessor: "tomador",
      },
      {
        Header: "Número",
        accessor: "numero_nota",
      },
      {
        Header: "Valor",
        disableSortBy: true,
        accessor: (row) => {
          return Format.formataValor(row.valor_nota || 0);
        },
      },
      {
        Header: "Data de emissão",
        disableSortBy: true,
        accessor: (row) => {
          return formataData(row.data_emissao);
        },
      },
      {
        Header: "Status",
        disableSortBy: true,
        Cell: ({ row }) => {
          let status = [];

          if (
            row.original.solicitacao_cancelamento &&
            row.original.status !== "CANCELADO"
          )
            status.push(
              <div>
                <Badge color="warning">Solicitado cancelamento</Badge>
              </div>
            );

          switch (row.original.status) {
            case "CONCLUIDO":
              status.push(
                <div>
                  <Badge color="success">Emitida</Badge>
                </div>
              );
              break;
            case "CANCELADO":
              status.push(
                <div>
                  <Badge color="danger">Cancelada</Badge>
                </div>
              );
              break;
            case "PROCESSANDO":
              status.push(
                <div>
                  <Badge color="primary">Processando</Badge>
                </div>
              );
              break;
            case "REJEITADO":
              status.push(
                <div>
                  <Badge color="orange">Rejeitada</Badge>
                </div>
              );
              break;
            case "SOLICITACAO CANCELAMENTO":
              status.push(
                <div>
                  <Badge color="warning">Processando cancelamento</Badge>
                </div>
              );
              break;
            case "INCOMPLETO":
              status.push(
                <div>
                  <Badge color="warning">Incompleta</Badge>
                </div>
              );
              break;
            case "DENEGADO":
              // status.push(
              //   <div>
              //     <Badge color="orange">Denegada</Badge>
              //   </div>
              // );
              status.push(
                <div>
                  <Badge color="success">Emitida</Badge>
                </div>
              );
              break;
            default:
              break;
          }

          return (
            <div>
              <div className="mb-2" role="group">
                {status}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [];
          var dataEmissao = new Date(row.original.data_emissao);
          var mesAnterior = "false";
          if (!isNaN(dataEmissao.getTime())) {
            var now = new Date();
            var currentMonth = now.getMonth();
            var currentYear = now.getFullYear();

            var dataEmissaoMonth = dataEmissao.getMonth();
            var dataEmissaoYear = dataEmissao.getFullYear();

            var isPreviousMonth =
              dataEmissaoYear < currentYear ||
              (dataEmissaoYear === currentYear &&
                dataEmissaoMonth < currentMonth);

            if (isPreviousMonth) mesAnterior = "true";
          }

          if (
            row.original.amazon === "ENO" &&
            row.original.status === "PROCESSANDO"
          )
            status.push(
              <DropdownButton
                key={`verificar-status-${row.original.uid}`}
                onClick={() => {
                  atualizarNota(row.original.uid);
                }}
                color="success"
                icon="mdi mdi-cloud-download"
              >
                Verificar status do processamento
              </DropdownButton>
            );
          if (
            row.original.amazon === "ENO" &&
            ["CONCLUIDO", "DENEGADO"].includes(row.original.status) &&
            row.original.pdf === null &&
            row.original.xml === null
          )
            status.push(
              <DropdownButton
                key={`download-pdf-${row.original.uid}`}
                onClick={() => {
                  downloadNotaFiscal(
                    row.original.uid,
                    "pdf",
                    `${row.original.tomador} - ${row.original.numero_nota}`
                  );
                }}
                color="success"
                icon="mdi mdi-cloud-download"
              >
                Download PDF
              </DropdownButton>
            );

          if (
            parseInt(session.codigo) >= 10 &&
            row.original.status === "CANCELADO"
          ) {
            status.push(
              <DropdownButton
                key={`inativar-nfse-${row.original.uid}`}
                onClick={() => {
                  inativarNotaFiscal(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-book-cancel"
              >
                Inativar NFS-e
              </DropdownButton>
            );
            // if (!isMobile)
            //   status.push(
            //     <DropdownButton
            //       key={`visualizar-${row.original.uid}`}
            //       onClick={() => {
            //         togVisualizarModal(row.original.uid);
            //       }}
            //       color="primary"
            //       icon="mdi mdi-file-search"
            //     >
            //       Visualizar
            //     </DropdownButton>
            //   );
          }

          if (
            parseInt(session.codigo) >= 10 &&
            ["REJEITADO", "DENEGADO"].includes(row.original.status)
          )
            status.push(
              <DropdownButton
                key={`inativar-nota-${row.original.uid}`}
                onClick={() => {
                  inativarNotaFiscal(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-book-cancel"
              >
                Inativar NFS-e
              </DropdownButton>
            );

          if (
            row.original.amazon === "ENO" &&
            ["CONCLUIDO", "DENEGADO"].includes(row.original.status) &&
            row.original.pdf !== null &&
            row.original.xml !== null
          ) {
            if (!isMobile)
              status.push(
                <DropdownButton
                  key={`visualizar-nota-${row.original.uid}`}
                  onClick={() => {
                    togVisualizarModal(row.original.uid);
                  }}
                  color="primary"
                  icon="mdi mdi-file-search"
                >
                  Visualizar
                </DropdownButton>
              );
            status.push(
              <>
                <DropdownButton
                  key={`download-nota-${row.original.uid}`}
                  onClick={() => {
                    downloadNotaFiscal(
                      row.original.uid,
                      "pdf",
                      `${row.original.tomador} - ${row.original.numero_nota}`
                    );
                  }}
                  color="success"
                  icon="mdi mdi-cloud-download"
                >
                  Download PDF
                </DropdownButton>
                <DropdownButton
                  key={`download-xml-${row.original.uid}`}
                  onClick={() => {
                    downloadNotaFiscal(
                      row.original.uid,
                      "xml",
                      `${row.original.tomador} - ${row.original.numero_nota}`
                    );
                  }}
                  color="warning"
                  icon="mdi mdi-xml"
                >
                  Download XML
                </DropdownButton>
              </>
            );

            if (parseInt(row.original.tipo_nota) === 3)
              status.push(
                <DropdownButton
                  key={`enviar-email-${row.original.uid}`}
                  onClick={() => {
                    togEnviarEmailModal(row.original.uid, row.original.amazon);
                  }}
                  color="info"
                  icon="mdi mdi-email-send"
                >
                  Enviar NFS-e por e-mail
                </DropdownButton>
              );
          }

          if (row.original.amazon === "SIM") {
            if (!isMobile && row.original.caminho)
              status.push(
                <DropdownButton
                  key={`visualizar-nfse-${row.original.uid}`}
                  onClick={() => {
                    togVisualizarModal(row.original.uid);
                  }}
                  color="primary"
                  icon="mdi mdi-file-search"
                >
                  Visualizar
                </DropdownButton>
              );

            if (row.original.caminho)
              status.push(
                <DropdownButton
                  key={`download-${row.original.uid}`}
                  onClick={() => {
                    downloadNotaFiscal(
                      row.original.uid,
                      "pdf",
                      `${row.original.tomador} - ${row.original.numero_nota}`
                    );
                  }}
                  color="success"
                  icon="mdi mdi-cloud-download"
                >
                  Download PDF
                </DropdownButton>
              );

            if (
              (row.original.xml || row.original.caminho) &&
              parseInt(row.original.tipo_nota) === 3
            )
              status.push(
                <DropdownButton
                  key={`email-${row.original.uid}`}
                  onClick={() => {
                    togEnviarEmailModal(row.original.uid, row.original.amazon);
                  }}
                  color="info"
                  icon="mdi mdi-email-send"
                >
                  Enviar NFS-e por e-mail
                </DropdownButton>
              );

            if (row.original.xml)
              status.push(
                <DropdownButton
                  key={`baixar-xml-${row.original.uid}`}
                  onClick={() => {
                    downloadDocumento(
                      row.original.xml,
                      "xml",
                      row.original.numero_nota
                    );
                  }}
                  color="warning"
                  icon="mdi mdi-xml"
                >
                  Download XML
                </DropdownButton>
              );
          }

          if (
            parseInt(session.codigo) >= 99 &&
            row.original.status === "SOLICITACAO CANCELAMENTO"
          )
            status.push(
              <DropdownButton
                key={`verificar-${row.original.uid}`}
                onClick={() => {
                  atualizarNota(row.original.uid);
                }}
                color="info"
                icon="mdi mdi-update"
              >
                Verificar status do cancelamento
              </DropdownButton>
            );

          if (parseInt(session.codigo) >= 99 && row.original.amazon === "SIM")
            status.push(
              <DropdownButton
                key={`excluir-arquivo-${row.original.uid}`}
                onClick={() => {
                  deleteNotaFiscal(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-delete"
              >
                Excluir arquivo
              </DropdownButton>
            );

          if (
            ["CONCLUIDO", "DENEGADO"].includes(row.original.status) &&
            row.original.amazon === "ENO"
          )
            status.push(
              <DropdownButton
                key={`utilizar-dados-${row.original.uid}`}
                onClick={() => {
                  window.location.href = `${baseUrl}contabilidade/notaFiscal/EmissorNotaFiscalServico/emissor?uid=${row.original.uid}`;
                }}
                color="primary"
                icon="mdi mdi-content-copy"
              >
                Utilizar dados da NFS-e
              </DropdownButton>
            );

          if (row.original.send_enotas && parseInt(session.codigo) === 99)
            status.push(
              <DropdownButton
                key={`visualizar-json-${row.original.uid}`}
                onClick={() => {
                  togVisualizarJson(row.original.send_enotas);
                }}
                color="warning"
                icon="mdi mdi-code-json"
              >
                Visualizar JSON
              </DropdownButton>
            );

          if (
            ((row.original.amazon === "ENO" &&
              ["CONCLUIDO", "DENEGADO"].includes(row.original.status) &&
              row.original.pdf != null &&
              row.original.xml != null) ||
              row.original.amazon === "SIM") &&
            !row.original.solicitacao_cancelamento &&
            row.original.status !== "CANCELADO"
          )
            status.push(
              <DropdownButton
                key={`solicitar-cancelamento-${row.original.uid}`}
                onClick={() => {
                  solicitarCancelamento(
                    row.original.uid,
                    row.original.tipo_nota,
                    mesAnterior
                  );
                }}
                color="danger"
                icon="mdi mdi-book-cancel"
              >
                Solicitar cancelamento da NFS-e
              </DropdownButton>
            );

          if (
            row.original.amazon === "ENO" &&
            ["CONCLUIDO", "DENEGADO"].includes(row.original.status) &&
            row.original.pdf !== null &&
            row.original.xml !== null &&
            parseInt(session.codigo) >= 99
          )
            status.push(
              <DropdownButton
                key={`cancelar-nfse-${row.original.uid}`}
                onClick={() => {
                  cancelarNotaFiscal(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-book-cancel"
              >
                Cancelar NFS-e
              </DropdownButton>
            );
          if (
            parseInt(session.codigo) === 99 &&
            ["CONCLUIDO", "DENEGADO"].includes(row.original.status)
          ) {
            status.push(
              <DropdownButton
                key={`cancelar-prefeitura-${row.original.uid}`}
                onClick={() => {
                  cancelarPrefeitura(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-book-cancel"
              >
                NFS-e cancelada pela prefeitura
              </DropdownButton>
            );
          }

          return status.length > 0 && <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [
      atualizarNota,
      baseUrl,
      cancelarNotaFiscal,
      cancelarPrefeitura,
      checkboxesMarcados,
      deleteNotaFiscal,
      downloadDocumento,
      downloadNotaFiscal,
      inativarNotaFiscal,
      isMobile,
      session.codigo,
      setCheckboxesMarcados,
      solicitarCancelamento,
      tiposNotaFiscal,
      togEnviarEmailModal,
      togVisualizarJson,
      togVisualizarModal,
    ]
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      botoes={
        <>
          {parseInt(session.codigo) === 99 && (
            <ButtonRounded
              color="primary"
              icon={<FaSync />}
              onClick={() => {
                sincronizarNotas();
              }}
            >
              Sincronizar
            </ButtonRounded>
          )}

          <ButtonRounded
            color="primary"
            onClick={() => {
              togEmailMassaModal();
            }}
          >
            E-mail em massa
          </ButtonRounded>
          <ButtonRounded
            color="success"
            onClick={() => {
              togDownloadMassaModal();
            }}
          >
            Download em massa
          </ButtonRounded>
          <ButtonRounded
            color="success"
            icon={<FaPlus />}
            onClick={() => {
              togUploadModal();
            }}
          >
            Nova nota fiscal
          </ButtonRounded>
        </>
      }
    />
  );
}

GerenciadorDataTable.propTypes = {
  linhas: PropTypes.arrayOf(PropTypes.object).isRequired,
  togUploadModal: PropTypes.func.isRequired,
  togVisualizarModal: PropTypes.func.isRequired,
  checkboxesHook: PropTypes.shape({
    checkboxesMarcados: PropTypes.arrayOf(PropTypes.string).isRequired,
    setCheckboxesMarcados: PropTypes.func.isRequired,
  }).isRequired,
  togEnviarEmailModal: PropTypes.func.isRequired,
  downloadNotaFiscal: PropTypes.func.isRequired,
  deleteNotaFiscal: PropTypes.func.isRequired,
  inativarNotaFiscal: PropTypes.func.isRequired,
  cancelarNotaFiscal: PropTypes.func.isRequired,
  solicitarCancelamento: PropTypes.func.isRequired,
  togDownloadMassaModal: PropTypes.func.isRequired,
  atualizarNota: PropTypes.func.isRequired,
  togVisualizarJson: PropTypes.func.isRequired,
  cancelarPrefeitura: PropTypes.func.isRequired,
  togEmailMassaModal: PropTypes.func.isRequired,
  sincronizarNotas: PropTypes.func.isRequired,
  downloadDocumento: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default GerenciadorDataTable;
